async function aSignAllProtoGoskey() {
	var table = document.getElementById("prototable");
	if (!table) {
		await aAlert("No table!");
		return;
	}
	var tds = new Array();
	$(".prottd").each(function (n, td) {
		tds[tds.length] = td;
	});
	var current = 0;
	var errors = 0;

	var filesToUpload = {};

	var uploadFilesToGK = async function () {

		var dt = new DataTransfer();
		for (var filenameGosKey in filesToUpload) {
			var fileInfo = getFileInfoFromName(filesToUpload[filenameGosKey].fileName);
			var bstr = atob(filesToUpload[filenameGosKey].data);
			var length = bstr.length;
			var u8arr = new Uint8Array(length);
			while (length--) {
				u8arr[length] = bstr.charCodeAt(length);
			}
			var file = new File([u8arr], filenameGosKey, {type: fileInfo.type});
			dt.items.add(file);
			console.log("adding", filesToUpload[filenameGosKey].fileName);
		}
		SignGosKeyFiles(dt.files, async function (signData) {
			for (var i = 0; i < dt.files.length; i++) {
				var filenameGosKey = dt.files[i].name;
				var sign = signData[filenameGosKey];
				if (!sign) {
					aAlert("Ошибка при подписывании документа!!!11");
					console.log("filename sign err", filenameGosKey);
					$("#waitDialog").dialog("close");
					return;
				}
				filesToUpload[filenameGosKey].sign = sign;
				var result = await aUploadSignedFile(filesToUpload[filenameGosKey].data, filenameGosKey, sign);
				if (!result) {
					await aAlert("Ошибка подписи протокола!");
					$("#waitDialog").dialog("close");
					return;
				}

				var el = document.querySelector("#rtd" + filesToUpload[filenameGosKey].lot + " .filelist");
				console.log("adding to", el, result);
				fileAddArray([result], el);
			}

			uploadSigns();
		});
		return;
	};


	var uploadSigns = function () {
		$("#waitDialog").dialog("close");
		document.getElementById("protoform").submit();
	};


	var processTd = async function (td) {
		var lot = td.getAttribute("lot");
		if ($("input[name=replaced" + lot + "]").val()) {
			//измененный файл
			if (current === tds.length - 1) {
				await uploadFilesToGK();
			} else {
				current++;
				await processTd(tds[current]);
			}
			return;
		}
		var href = document.getElementById("a" + lot).href + "&base64";
		document.getElementById("protolog").innerHTML = document.getElementById("protolog").innerHTML + "<br>Формируем протокол №" + (current + 1) + "...";
		document.getElementById("protolog").scrollTop = 99999999;
		$("#waitDialog").dialog("open");
		var data = await aGetData(href);
		if (!data || data?.success === false) {
			document.getElementById("protolog").innerHTML = document.getElementById("protolog").innerHTML + "ОШИБКА ПОЛУЧЕНИЯ!<br>";
			document.getElementById("protolog").scrollTop = 99999999;
			await aAlert("Ошибка при подписывании протоколов!");
			$("#waitDialog").dialog("close");
			return;
		}
		if (data === "noauth") {
			await aAlert("Ошибка сессии! Необходима авторизация!");
			showPostAuthDialog();
			return;
		}
		let fileName = document.getElementById("a" + lot).text.trim();

		var fileItem = {data: data, fileName: fileName, lot: lot};
		filesToUpload[fileName.toGoskeyFileName()] = fileItem;

		document.getElementById("protolog").innerHTML = document.getElementById("protolog").innerHTML + "Готово!";
		document.getElementById("protolog").scrollTop = 99999999;
		if (current === tds.length - 1) {
			await uploadFilesToGK();
		} else {
			current++;
			await processTd(tds[current]);
		}
	};
	await processTd(tds[current]);
}


async function aSignAllProto() {
	if (useGosKey) {
		return aSignAllProtoGoskey();
	}

	var table = document.getElementById("prototable");
	document.getElementById("protolog").innerHTML = "";
	if (!table) {
		await aAlert("No table!");
		return;
	}
	var tds = new Array();
	$(".prottd").each(function (n, td) {
		tds[tds.length] = td;
	});
	var current = 0;
	var errors = 0;
	var processTd = async function (td, retry) {
		if (void 0 === retry) {
			retry = false;
		}
		var lot = td.getAttribute("lot");
		if ($("input[name=replaced" + lot + "]").val()) {
			//измененный файл
			if (current === tds.length - 1) {
				$("#waitDialog").dialog("close");
				document.getElementById("protoform").submit();
			} else {
				current++;
				await processTd(tds[current]);
			}
			return;
		}
		if(document.getElementById("a" + lot) === null){
			await aAlert("Приложите протокол о результатах проведения торгов!");
			return;
		}
		var href = document.getElementById("a" + lot).href + "&base64";
		if (!retry) {
			document.getElementById("protolog").innerHTML = document.getElementById("protolog").innerHTML + "<br>Подписываем протокол №" + (current + 1) + "...";
			document.getElementById("protolog").scrollTop = 99999999;
			$("#waitDialog").dialog("open");
		}

		var data = await aGetData(href);
		if (!data || data?.success === false) {
			errors++;
			if (errors > 10) {
				document.getElementById("protolog").innerHTML = document.getElementById("protolog").innerHTML + "ОШИБКА ПОЛУЧЕНИЯ!<br>";
				document.getElementById("protolog").scrollTop = 99999999;
				await aAlert("Ошибка при подписывании протоколов!");
				$("#waitDialog").dialog("close");
			} else {
				await processTd(tds[current], true);
			}
			return;
		}
		errors = 0;
		if (data === "noauth") {
			await aAlert("Ошибка сессии! Необходима авторизация!");
			showPostAuthDialog();
			return;
		}
		let fileName = document.getElementById("a" + lot).text;
		var result = await aSignBase64FileAndUpload(data, fileName);
		if (!result) {
			
//			await aAlert("Ошибка подписи протокола!"); //Выскакивает при закрытии выбора сертификата 0003888: 4 Подпись протоколов - убрать ошибку при отмене.
			$("#waitDialog").dialog("close");
			return;
		}
		var el = document.querySelector("#rtd" + lot + " .filelist");
		fileAddArray([result], el);
		console.log("result", result);
		document.getElementById("protolog").innerHTML = document.getElementById("protolog").innerHTML + (result.success ? "Готово!" : "Ошибка!");
		document.getElementById("protolog").scrollTop = 99999999;
		if (!result.success) {

		}
		if (current === tds.length - 1) {
			$("#waitDialog").dialog("close");
			document.getElementById("protoform").submit();
		} else {
			current++;
			await processTd(tds[current]);
		}
	};
	await processTd(tds[current]);
}

function aBase64ToBlob(data) {
	var bstr = atob(data);
	var len = bstr.length;
	var u8arr = new Uint8Array(len);
	while (len--) {
		u8arr[len] = bstr.charCodeAt(len);
	}
	return u8arr;
}

async function aSignBase64FileAndUpload(data, filename) {
	if (void 0 === window['UPLOAD_FILS']) {
		window['UPLOAD_FILS'] = new UploadFileProcessor();
	}
	var sign = null;
	try {
		sign = await SignAsync(data, true, true, null, true);
	} catch (e) {

	}


	if (!sign) {
		return false;
	}

	return await aUploadSignedFile(data, filename, sign);

}

async function aUploadSignedFile(data, filename, sign) {
	let fileInfo = getFileInfoFromName(filename);
	let file = new File([aBase64ToBlob(data)], filename, {type: fileInfo.type});
	let container = new DataTransfer();
	container.items.add(file);
	let fd = new FormData();
	fd.append("0", container.files[0]);
	fd.append("sign0", sign);
	var upload_file_idx = UPLOAD_FILS.push(file);
	var result = await jQuery.ajax({
		url: 'fileUpload',
		type: 'POST',
		data: fd,
		cache: false,
		dataType: 'html',
		processData: false,
		contentType: false,
		success: function (respond, status, jqXHR) {
			UPLOAD_FILS.done(upload_file_idx);
		},
		// функция ошибки ответа сервера
		error: function (jqXHR, status, errorThrown) {
			UPLOAD_FILS.error(upload_file_idx);
		},

		xhr: function () {
			var myXhr = $.ajaxSettings.xhr();
			if (myXhr.upload) {
				myXhr.upload.addEventListener('progress', function (e) {
					if (e.lengthComputable) {
						UPLOAD_FILS.progress(upload_file_idx, e);
						var percentComplete = Math.round(e.loaded / e.total * 100);
						var percentVal = percentComplete + '%';
					}
				}, false);
			}
			return myXhr;
		}});
	if (!result) {
		await aAlert("Ошибка!");
	}
	var result;
	try {
		result = JSON.parse(result)[0];
	} catch (e) {

	}
	return result;
}

async function aValidateDate(s, error) {
	if (!error) {
		error = {};
	}
	var separators = ['\\.'];
	var bits = s.split(new RegExp(separators.join('|'), 'g'));
	var d = new Date(bits[2], bits[1] - 1, bits[0]);
	var ret = d.getFullYear() == bits[2] && d.getMonth() + 1 == bits[1];
	if (ret) {
		return true;
	}
	error.message = "Неверный формат даты!";
	return false;
}

async function aCheckFormFields(formId) {
	var x = true;
	var errors = [];
	var req_el;
	for (const item of jQuery("#" + formId + " input.datepicker:visible").toArray()) {
		var val = $(item).val();
		var isValid = await aValidateDate(val);
		if (val && !isValid) {
			if (!req_el)
				req_el = item;
			x = false;
			errors.push({item:item});
		}
	}

	if (!x) {
		await aAlert("Неправильный формат даты!");
		if (req_el)
			req_el.focus();
		return false;
	}
	for (const item of jQuery("#" + formId + " input[type=text]").toArray()) {
		$(item).blur();
		var val = $(item).val();
		if (typeof val === "string") {
			$(item).val(val.trim().replace(/\s+/g, ' '));
		}
	}
	for (const item of jQuery("#" + formId + " [required][type=checkbox]:not(:checked)").toArray()) {
		if (!req_el)
			req_el = item;
		x = false;
		errors.push({item:item});
	}
	if (!x) {
		console.log(errors);
		await aAlert("Не все обязательные галочки поставлены!");
		if (req_el)
			req_el.focus();
		return false;
	}
	for (const item of jQuery("#" + formId + " input[inputmask]:visible").toArray()) {
		if (!$(item).inputmask("isComplete") && $(item).val() !== "") {
			if (!req_el)
				req_el = item;
			x = false;
			errors.push({item:item});
		}
	}
	for (const item of jQuery("#" + formId + " [required]").toArray()) {
		if (!item.value) {
			if (!req_el)
				req_el = item;
			x = false;
			errors.push({item:item});
		}
	}
	for (const item of jQuery("#" + formId + " [required_hidden]").toArray()) {
		if (!item.value) {
			if (!req_el)
				req_el = item;
			x = false;
			errors.push({item:item});
		}
	}
	if (!x) {
		console.log(errors);
		await aAlert("Не все обязательные поля заполнены!");
		if (req_el)
			req_el.focus();
		return false;
	}
	for (const item of jQuery("#" + formId + " [isnum]").toArray()) {
		if (x) {
			var val = item.value.replace(/ /gi, "").replace(",", ".");
			if (isNaN(val)) {
				await aAlert("Неверное число!");
				x = false;
				item.focus();
			} else {
				var type = $(item).attr("isnum");
				if (type === "natural" || type === "real") {
					if (val <= 0 && val !== "") {
						aAlert("Нулевое значение недопустимо!").then(() => {
							x = false;
							item.focus();
						});
					}
				}
			}
		}
	}
	if (!x) {
		return false;
	}

	for (const item of jQuery("#" + formId + " .filereq:visible").toArray()) {
		if (jQuery(".attfile:not(.removed)", item).length === 0) {
			await aAlert("Приложите документы: " + $(".filetitle", item).html());
			$('html, body').animate({scrollTop: $(item).offset().top + item.clientHeight - $(window).height() / 2}, 200);
			x = false;
			return false;
		}
	}

	if (!x) {
		return false;
	}

	var file_msg = "Не все требуемые файлы приложены!";
	for (const item of jQuery("#" + formId + " [file_required]:not([disabled])").toArray()) {
		if (!item.value) {
			if ($(item).attr("data-miss-title")) {
				file_msg = $(item).attr("data-miss-title");
			}
			x = false;
			nof = item;
		}
	}
	if (!x) {
		await aAlert(file_msg);
		return false;
	}
	return true;
}

async function aSignForm(formId, formName, checkUrl, noSign, onSign) {
	signFormParams = null;
	var form = $("#" + formId)[0];
	if ($(form).attr("data-confirm") && !await aConfirm($(form).attr("data-confirm"))) {
		return false;
	}

	var check = await aCheckFormFields(formId);
	if (!check)
		return false;
	var signData = null;
	var formData = new FormData(form);
	var data = null;
	if (checkUrl) {
		formData.append('check', '1');
		data = await aPostData(checkUrl, formData);
	} else {
		formData.append('formname', formName);
		var data = await aPostData("SignTools", formData);
	}
	if (typeof data !== "object") {
		data = eval("(" + data + ")");
	}
	if (data === null) {
		await aAlert("Ошибка!!");
		return false;
	}
	if (data.noauth) {
		if (data.act === "bid") {
			signFormParams = {formId: formId, formName: formName, checkUrl: checkUrl};
			showAuthDialog();
			return false;
		}
		if (data.act === "auth") {
			showAuthDialog();
			return false;
		}
		if (data.act === "alert") {
			await aAlert("Вы не авторизованы!");
			return false;
		}
	}
	if (data.errors) {
		await aAlert(data.errors);
		return false;
	}
	if (data.warnings && !(await aConfirm(data.warnings + "\n\nПродолжить?"))) {
		return false;
	}

	signData = data.form_txt;
	if (checkUrl) {
//???????
//submit();
	}

	if (data.form_txt === null || data.text === null) {
		await aAlert("Ошибка!!");
		return false;
	}

	var isAllowSign = await aConfirm(data.form_txt, "Подписать");
	if (isAllowSign) {
		if (noSign) {
			if (typeof onSign === "function") {
				return await onSign();
//				return false;
			}
			form.submit();
			return false;
		}
		return await signSendForm((useGosKey ? data.text : data.form_txt), formId, onSign);
		return false;
	}

	return false;
}

async function aSignFormResult(formId, formName, checkUrl) {
	var form = $("#" + formId)[0];
	if ($(form).attr("data-confirm") && !await aConfirm($(form).attr("data-confirm"))) {
		return false;
	}
	if (!await aCheckFormFields(formId)) {
		return false;
	}
	var formData = new FormData(form);
	var data;
	if (checkUrl) {
		formData.append('check', '1');
		data = await aPostData(checkUrl, formData);
	} else {
		formData.append('formname', formName);
		data = await aPostData("SignTools", formData);
	}
	if (data?.errors) {
		await aAlert(data?.errors);
		return false;
	}
	if (data?.warnings && !(await aConfirm(data?.warnings + "\n\nПродолжить?"))) {
		return false;
	}
	if (data?.form_txt === null || data?.text === null) {
		await aAlert("Ошибка!!");
		return false;
	}
	if (await aConfirm(data?.form_txt, "Подписать")) {
		return await SignAsync((useGosKey ? data.text : data.form_txt), false, false, false, true);
	}
	return false;
}